@if (webhook(); as w) {
  <div class="flex flex-col gap-4">
    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
          <i class="pi pi-info-circle text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Información general</span>
      </div>
      <div class="p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div class="sm:col-span-2">
            <p class="text-xs font-medium text-slate-500">Endpoint</p>
            <p class="text-sm font-semibold text-slate-900 break-all font-mono">{{ w.endpoint || '—' }}</p>
            @if (w.description) {
              <p class="text-xs text-slate-500 mt-0.5">{{ w.description }}</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Estado</p>
            <p-tag class="!text-xs" [value]="w.enabled ? 'Activo' : 'Inactivo'" [severity]="w.enabled ? 'success' : 'secondary'" />
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Método</p>
            <p class="text-sm text-slate-700 font-mono">{{ w.method || 'POST' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Fecha de creación</p>
            <p class="text-sm text-slate-700">{{ w.createdAt ? (w.createdAt | date:'dd/MM/yyyy HH:mm') : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Última actualización</p>
            <p class="text-sm text-slate-700">{{ w.updatedAt ? (w.updatedAt | date:'dd/MM/yyyy HH:mm') : '—' }}</p>
          </div>
        </div>
      </div>
    </div>

    @if (w.secret) {
      <div class="rounded-xl border border-amber-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center gap-2 px-4 py-2.5 bg-amber-50 border-b border-amber-200">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-amber-100 text-amber-700">
            <i class="pi pi-lock text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-amber-900 uppercase tracking-wide">Signing secret</span>
        </div>
        <div class="p-4">
          <code class="break-all text-sm text-amber-950 font-mono">{{ w.secret }}</code>
          <p class="m-0 mt-2 text-xs text-amber-800/90">
            Úsalo para validar <code>Pento-Signature</code> en tu servidor.
          </p>
        </div>
      </div>
    }

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-100 text-violet-600">
          <i class="pi pi-bolt text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">
          Eventos suscritos ({{ w.subscribedEvents?.length ?? 0 }})
        </span>
      </div>
      @if (w.subscribedEvents?.length) {
        <div class="flex flex-wrap gap-1.5 px-4 py-3">
          @for (event of w.subscribedEvents; track event) {
            <span class="text-[11px] px-2 py-0.5 rounded bg-sky-50 text-sky-800 font-mono">{{ eventLabel(event) }}</span>
          }
        </div>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin eventos suscritos.</p>
      }
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
          <i class="pi pi-list text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">
          Headers ({{ headerEntries().length }})
        </span>
      </div>
      @if (headerEntries().length) {
        <div class="divide-y divide-slate-100">
          @for (header of headerEntries(); track header.key) {
            <div class="flex items-start gap-2 px-4 py-2">
              <div class="min-w-0 flex-1">
                <span class="text-[11px] font-semibold text-slate-600 uppercase">{{ header.key }}</span>
                <p class="text-xs text-slate-900 leading-snug mt-0.5 font-mono break-all">{{ header.value }}</p>
              </div>
            </div>
          }
        </div>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin headers personalizados.</p>
      }
    </div>
  </div>
}
